import Customer from 'pages/customer/Customer';

export const routes = [
  { path: '/customer' as const, component: Customer, disabled: false },
];

export default routes;
